import React from 'react';
import styled from 'App/styled';
import { useTheme } from 'emotion-theming';

import { SearchSuggestion } from 'types/searchSuggestion';
import { getHighlightedSearchField } from 'helpers/utils/search/searchSuggestion';


interface ButtonProps {
  textColor: string;
}

const Button = styled.button`
  background-color: #ffffff;
  display: flex;
  align-items: center;
  text-decoration: none;
  color: ${({ textColor }: ButtonProps) => textColor};
  margin-block: 5px;
  margin-inline: 15px;
  border: 1px solid #e1e1e1;
  padding: 10px;
  ${({ theme }) => theme.typography.bodyMedium};

  img {
    width: 60px;
    height: 60px;
    background: #999;
    margin-inline-end: 10px;
  }

  span {
    text-align: start;
  }
`;


interface ProductSuggestionProps {
  suggestion: SearchSuggestion;
  searchField: string;
  index: number;
  handleClick: (suggestion: SearchSuggestion, position: number) => void;
}

function ProductSuggestion({
  suggestion,
  searchField,
  handleClick,
  index,
}: ProductSuggestionProps) {
  const theme: Theme = useTheme();
  const { q, image } = suggestion;
  const { partBefore, partMatching, partAfter, match } = getHighlightedSearchField(searchField, q);
  return (
    <Button
      textColor={theme.darkGrey}
      key={q}
      type="button"
      onClick={() => handleClick(suggestion, index + 1)}
    >
      <img src={image} alt="popular product" />
      {
        match ? (
          <span>
            {partBefore}
            <b>{partMatching}</b>
            {partAfter}
          </span>
        ) : (
            q
          )
      }
    </Button>
  );
}

export default ProductSuggestion;
